import { render, staticRenderFns } from "./DosingPackages.vue?vue&type=template&id=6fa811da&scoped=true&"
import script from "./DosingPackages.vue?vue&type=script&lang=js&"
export * from "./DosingPackages.vue?vue&type=script&lang=js&"
import style0 from "./DosingPackages.vue?vue&type=style&index=0&id=6fa811da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa811da",
  null
  
)

export default component.exports